import { DOCUMENT, Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { PermissionsInfoOptions } from '@frontend/geo-coordinator/client-models';
import { Logger } from '@frontend/vanilla/core';

import { PermissionsManagerComponent } from './permissions-manager.component';

@Injectable({ providedIn: 'root' })
export class GeoCoordinatorPermissionsManagerService {
    private readonly dialog = inject(MatDialog);
    private readonly documentRef = inject(DOCUMENT);
    private readonly logger = inject(Logger);

    private dialogRef: MatDialogRef<PermissionsManagerComponent> | null = null;
    private _permissionsInfoOptions: PermissionsInfoOptions | null = null;

    handlePermissionsInfo(options: PermissionsInfoOptions): void {
        this.logger.info('[GeoCoordinatorPermissionsManagerService]', '[handlePermissionsInfo]', options);
        this.logger.infoRemote(`[GeoCoordinatorPermissionsManagerService] [handlePermissionsInfo] [${JSON.stringify(options.permissionsInfo)}]`);

        if (this.canReopenDialog(this._permissionsInfoOptions, options)) {
            this.closePermissionsInfo();
            this._permissionsInfoOptions = options;
            this.dialogRef = this.dialog.open(PermissionsManagerComponent, {
                width: '100%',
                disableClose: true,
                data: {
                    permissionsInfo: options.permissionsInfo,
                    permissionsConfig: options.textDictionary,
                    geoCoordinatorService: options.geoCoordinatorService,
                },
                panelClass: 'geo-permission-manager-popup',
            });
        }
        this.handleDialogClassesDecoration(['geo-location-permission-overlay', 'cdk-global-scrollblock'], this.dialogRef, this.documentRef);
    }

    closePermissionsInfo() {
        if (this.dialogRef) {
            this.dialogRef.close();
            this._permissionsInfoOptions = null;
        }
    }

    private handleDialogClassesDecoration(
        whichClasses: string[],
        dialogRef: MatDialogRef<PermissionsManagerComponent> | null,
        documentRef: Document,
    ) {
        if (dialogRef) {
            dialogRef.afterOpened().subscribe(() => {
                if (documentRef) {
                    whichClasses.forEach((cls) => {
                        documentRef.documentElement.classList.add(cls);
                    });
                }
            });
            dialogRef.afterClosed().subscribe(() => {
                if (documentRef) {
                    whichClasses.forEach((cls) => {
                        documentRef.documentElement.classList.remove(cls);
                    });
                }
                // this._permissionsInfoOptions = null;
            });
        }
    }

    private canReopenDialog(existing: PermissionsInfoOptions | null, incoming: PermissionsInfoOptions | null) {
        if (!existing && !incoming) {
            return true;
        }

        if (existing || incoming) {
            if (existing !== incoming) {
                return !(
                    existing?.permissionsInfo?.status === incoming?.permissionsInfo?.status &&
                    existing?.permissionsInfo?.reason === incoming?.permissionsInfo?.reason
                );
            }
        }
        return false;
    }
}
